function update_wastage($element) {
    var $form = $element.closest('form');
    var source_quantity = $form.find('#quantity').val();
    var source_unit = $form.find('#unit').val();
    var price = $form.find('#price').val();
    var wastage = $element.find('input[name="wastage_value[]"]').val();
    var $price = $element.find('.wastage-price');
    var $amount = $element.find('.wastage-price-amount');

    //Ensure all needed fields are here before calcing price
    if(price && wastage) {

        //Set loading on price
        $amount.html('');
        $price.html("...");

        //Load in the ingredient wastages
        ajax_call('get', '/admin/get_wastage_price/' + price + '/' + wastage, {}, function(resp) {

            //If successful...
            if(resp.response) {

                //Replace the wastage select with our new one
                $price.html(resp.content);
                $amount.html('(' + source_quantity + ' ' + source_unit + ')');

            } else {
                alert(resp.message);
            }
        });
    }
}

function add_measurement_row($button) {
    var $form = $button.closest('form');
    var $container = $form.find('.measurement-container');
    var $cloneable = $container.find('.cloneable');

    //Clone cloneable measurement row and append to container
    var $row = $cloneable.clone();
    $row.removeClass('cloneable').addClass('visible');
    $row.find('input[disabled], select[disabled]').removeAttr('disabled');
    $row.find('.no-touchy').removeClass('no-touchy');
    $row.appendTo($container);

    $('.measurement-hint').hide();

    init_selects();

    return $row;

}

function add_wastage_row($button) {
    var $form = $button.closest('form');
    var $container = $form.find('.wastage-container');
    var $cloneable = $container.find('.cloneable');

    //Clone cloneable measurement row and append to container
    var $row = $cloneable.clone();
    $row.removeClass('cloneable').addClass('visible');
    $row.find('input[disabled]').removeAttr('disabled');
    $row.appendTo($container);

    $('.wastage-hint').hide();
    init_basic_tooltips();
    init_popovers();

    return $row;
}

$(function() {

    $body.on('click', '#add-measurement-row', function(e) {
        e.preventDefault();
        add_measurement_row($(this));
    });

    $body.on('click', '#add-wastage-row', function(e) {
        e.preventDefault();
        add_wastage_row($(this));
    });

    //Change measurement quantity/unit on ingredient form
    $body.on('change', '#edit-ingredient-form input[name="measurement_source_quantity[]"], #edit-ingredient-form select[name="measurement_source_unit[]"], ' +
        '#popup-edit-ingredient-form input[name="measurement_source_quantity[]"], #popup-edit-ingredient-form select[name="measurement_source_unit[]"], ' +
        '#popup-ingredient-form input[name="measurement_source_quantity[]"], #popup-ingredient-form select[name="measurement_source_unit[]"]', function(e) {
        var $row = $(this).closest('.measurement-row');
        var $form = $(this).closest('form');

        var source_quantity = parseFloat($form.find('#quantity').val());
        var source_unit = $form.find('#unit').val();
        var source_price = parseFloat($form.find('#price').val());
        var target_quantity = parseFloat($row.find('input[name="measurement_source_quantity[]"]').val());
        var target_unit = $row.find('select[name="measurement_source_unit[]"]').val();
        var $price = $row.find('.measurement-price');

        //Ensure all needed fields are here before calculating price
        if(source_quantity && source_unit && source_price && Number.isFinite(target_quantity) && target_unit) {

            //Set loading on price
            $price.html("...");

            //Load in the ingredient wastages
            ajax_call('get', '/admin/get_price/' + source_quantity + '/' + source_unit + '/' + target_quantity + '/' + target_unit + '/' + source_price, {}, function(resp) {

                //If successful...
                if(resp.response) {

                    //Replace the wastage select with our new one
                    $price.html(resp.content);

                } else {
                    alert(resp.message);
                }
            });
        }

    });

    //Update wastages on unit change
    $body.on('change', '#edit-ingredient-form #quantity, #edit-ingredient-form #unit, ' +
        '#popup-edit-ingredient-form #quantity, #popup-edit-ingredient-form #unit, ' +
        '#popup-ingredient-form #quantity, #popup-ingredient-form #unit', function(e) {
        var $form = $(this).closest('form');

        var $wastages = $form.find('.wastage-row:not(.cloneable)');
        var source_quantity = $form.find('#quantity').val();
        var source_unit = $form.find('#unit').val();

        //If at least one (non-cloneable) wastage row
        if($wastages.length > 0) {

            //Loop over each wastage and update prices/unit
            $.each($wastages, function(i, v) {
                var $amount = $(this).find('.wastage-price-amount');

                $amount.html('(' + source_quantity + ' ' + source_unit + ')');

            });

        }

    });

    //Update wastages on change
    $body.on('change', '#edit-ingredient-form #price, #edit-ingredient-form input[name="wastage_value[]"], ' +
        '#popup-edit-ingredient-form #price, #popup-edit-ingredient-form input[name="wastage_value[]"], ' +
        '#popup-ingredient-form #price, #popup-ingredient-form input[name="wastage_value[]"]', function(e) {
        var $wastages = $('.wastage-row:not(.cloneable)');
        var $parent = $(this).closest('.wastage-row:not(.cloneable)');

        //If at least one (non-cloneable) wastage row
        if($wastages.length > 0) {

            if($parent.length > 0) {
                update_wastage($parent);

            } else {

                //Loop over each wastage and update prices/unit
                $.each($wastages, function(i, v) {
                    update_wastage($(this));
                });

            }

        }

    });

    //Update measurements on change
    $body.on('change', '#edit-ingredient-form #price, #edit-ingredient-form #quantity, #edit-ingredient-form #unit, ' +
        '#popup-edit-ingredient-form #price, #popup-edit-ingredient-form #quantity, #popup-edit-ingredient-form #unit, ' +
        '#popup-ingredient-form #price, #popup-ingredient-form #quantity, #popup-ingredient-form #unit', function(e) {
        var $measurements = $('.measurement-row:not(.cloneable)');
        var $form = $(this).closest('form');

        //If at least one (non-cloneable) measurement row
        if($measurements.length > 0) {

            //Loop over each measurement and update prices
            $.each($measurements, function(i, v) {

                var source_quantity = parseFloat($form.find('#quantity').val());
                var source_unit = $form.find('#unit').val();
                var source_price = parseFloat($form.find('#price').val());
                var target_quantity = parseFloat($(this).find('input[name="measurement_source_quantity[]"]').val());
                var target_unit = $(this).find('select[name="measurement_source_unit[]"]').val();
                var $price = $(this).find('.measurement-price');

                //Ensure all needed fields are here before calculating price
                if(source_quantity && source_unit && source_price && Number.isFinite(target_quantity) && target_unit) {

                    //Set loading on price
                    $price.html("...");

                    //Load in the ingredient wastages
                    ajax_call('get', '/admin/get_price/' + source_quantity + '/' + source_unit + '/' + target_quantity + '/' + target_unit + '/' + source_price, {}, function(resp) {

                        //If successful...
                        if(resp.response) {

                            //Replace the wastage select with our new one
                            $price.html(resp.content);

                        } else {
                            alert(resp.message);
                        }
                    });
                }

            });

        }

    });

    //Change unit on ingredient
    $body.on('change', '#edit-ingredient-form #unit, #popup-ingredient-form #unit, #popup-edit-ingredient-form #unit', function(e) {
        var $form = $(this).closest('form');

        var unit = $(this).find("option:selected").val();
        var type = $(this).find("option:selected").data('type');

        //Only allow units with same type
        var $source_options = $form.find('select[name="measurement_source_unit[]"] option[data-type]');
        var $target_options = $form.find('select[name="measurement_target_unit[]"] option[data-type]');

        $.each($source_options, function(i, v) {

            if($(this).data('type') !== type) {
                $(this).hide();

                //Deselect chosen option if it's now hidden
                if($(this).is(':selected')) {
                    $(this).prop('selected', false);
                }

            } else {

                //For custom units, only show the chosen one
                if(type === 'custom') {
                    if(unit === $(this).val()) {
                        $(this).show();
                    } else {
                        $(this).hide();

                        //Deselect chosen option if it's now hidden
                        if($(this).is(':selected')) {
                            $(this).prop('selected', false);
                        }
                    }
                } else {
                    $(this).show();
                }

            }

            $(this).closest('select').trigger('chosen:updated');
        });

        $.each($target_options, function(i, v) {

            //For custom units, only hide the exact unit
            if(type === 'custom') {
                if(unit === $(this).val()) {
                    $(this).hide();

                    //Deselect chosen option if it's now hidden
                    if($(this).is(':selected')) {
                        $(this).prop('selected', false);
                    }
                } else {
                    $(this).show();
                    $(this).parent().show();
                }

            } else if($(this).data('type') === type) {
                $(this).hide();
                $(this).parent().hide();

                //Deselect chosen option if it's now hidden
                if($(this).is(':selected')) {
                    $(this).prop('selected', false);
                }
            } else {
                $(this).show();
                $(this).parent().show();
            }

            $(this).closest('select').trigger('chosen:updated');
        });

    });

    //Trigger unit check on load
    $('#edit-ingredient-form #unit, #popup-ingredient-form #unit, #popup-edit-ingredient-form #unit').trigger('change');

    //Reset unsaved flag after this change trigger, or we get false unsaved changes
    unsaved = false;

});
